import React from 'react';
import styles from './style.module.scss';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { taskEnum } from 'shared/utils/Enum';

const RecentActivity = ({ data }) => {
    const { theme: { theme } } = useSelector((state) => state.root);

    const getTypeDetails = (item) => {
        switch (item.type) {
            case 'task':
                let variant = 'primary';
                if (item.status === taskEnum.COMPLETED) variant = 'success';
                else if (item.status === taskEnum.INPROGESS) variant = 'info';
                else if (item.status === taskEnum.PENDING) variant = 'warning';
                return { variant, label: 'Task' };
            case 'po':
                return { variant: 'primary', label: 'PO' };
            case 'inventory':
                return { variant: 'info', label: 'Inventory' };
            case 'so':
                return { variant: 'success', label: 'Sale Order' };
            case 'return':
                return { variant: 'warning', label: 'Return' };
            default:
                return { variant: 'primary', label: 'Activity' };
        }
    };

    const activities = data && Array.isArray(data) ? data.map(item => {
        const { variant, label } = getTypeDetails(item);
        return {
            ...item,
            variant,
            label,
            formattedTime: moment(item.time).calendar(null, {
                sameDay: '[Today at] h:mm A',
                nextDay: '[Tomorrow at] h:mm A',
                nextWeek: 'dddd [at] h:mm A',
                lastDay: '[Yesterday at] h:mm A',
                lastWeek: '[Last] dddd [at] h:mm A',
                sameElse: 'DD MMM YYYY, h:mm A'
            })
        };
    }) : [];

    return (
        <div className={classNames(styles.ActivityContainer, styles.SummaryCard, `${theme}SummaryContainer`)}>
            <h5 className={classNames(styles.Title, `${theme}FontColor`)}>Recent Activity</h5>
            <div className={styles.List}>
                {activities.length > 0 ? activities.map((item) => (
                    <div key={item.id} className={styles.Item}>
                        <div className={classNames(styles.Avatar, styles[item.variant])}>
                            {item.label.charAt(0)}
                        </div>
                        <div className={styles.Content}>
                            <p className={classNames(styles.Text, `${theme}FontColor`)}>
                                <span className={styles.User}>{item.label}:</span> {item.title}
                                {item.subTitle && <span className={classNames(styles.Target, 'ms-1')}>({item.subTitle})</span>}
                            </p>
                            <span className={styles.Time}>{item.formattedTime}</span>
                        </div>
                    </div>
                )) : <p className={classNames(styles.Text, `${theme}FontColor`)}>No recent activity</p>}
            </div>
        </div>
    );
};

export default RecentActivity;
